import ProgrammeImage1 from "../../../../../assets/images/png/courses/programme1.webp";
import TestimonialImage from "../../../../../assets/images/png/courses/testimonies/liyide.jpeg";
import SchoolImage from "../../../../../assets/images/png/school/cloud-school.webp";

export const blockchainSchoolDataAfrica = {
  tag: "Blockchain Developer",
  id: "blockchainDeveloperProgramSchool",
  url: "/blockchain-developer-school",
  image: SchoolImage,

  name: "Blockchain Developer School",
  description: `
  The global demand for blockchain developers is growing so fast and Utiva’s learning program is designed to help you get into this space. 
  `,
  keywords: `blockchain, blockchain developer school, ethereum`,
  metatags: `Utiva is the best place to learn blockchain development in Nigeria. We train you and help you become certified in blockchain development.`,

  courses: [
    {
      id: 2,
      courseImage: ProgrammeImage1,
      courseName: "Become a Blockchain Developer",
      courseDescription: `
      In this program, you'll work with the Bitcoin and Ethereum protocols, work on real 
      projects from the Utiva partners and execute real-world applications, and 
      gain the essential skills for a career in this dynamic space.
      `,
      courseStartDate: "December 2, 2023",

      courseDuration: "6 Months",

      courseTags: ["For Early Professionals"],

      courseUrl: "/blockchain-developer-bootcamp",

      enrolUrl: "",
    },
  ],
  testimony: {
    testimonierImage: TestimonialImage,
    testimonierName: "Ajibola Liyide",
    testimonierTitle: "Internal, External and Media Relations",
    testimonyDescription: `The Utiva training with Utiva has been challenging and inspiring. 
    Challenging because it is at the same time as the re-branding project in my office. Inspiring 
    because I have learnt a lot so far. The key point is that the user experience is the most important factor to add value and provide solutions. `,
  },

  article: [],

  careerTitle: "Blockchain Developer",

  careerPaths: ["Blockchain Engineer"],

  quickFactSalary: "$124,000 ",

  quickFacts: [
    "Blockchain Developer has been identified as one of the skills for the future of work, according to a 2021 report by the World Economic Forum, citing it as the next wave of information technology for individuals, companies and governments.",
  ],
};
